var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',[_c('tbody',_vm._l((_vm.value),function(partQuantity){return _c('tr',{key:partQuantity.id},[_c('td',{staticClass:"pr-3"},[_vm._v(_vm._s(_vm._f("part")(partQuantity.part)))]),_c('td',{staticClass:"right"},[_vm._v(_vm._s(partQuantity.quantity)+" "+_vm._s(_vm._f("unit")(partQuantity.part.trackingUnit.unit)))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }